import {eventChannel} from 'redux-saga';
import {select, take, fork, put, call} from 'redux-saga/effects';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as samcActionTypes from '../samcActionTypes';
import config from '../../config';

const onSAMCMapClickFetchDamageLocationAddress = function* onSAMCMapClickFetchDamageLocationAddress(payload) {
    const {serviceAssignmentId} = payload;
    const {serviceManager} = yield select(state => state.application);
    const arcGISRESTService = serviceManager.loadService('arcGISRESTService');
    const arcGISMapService = serviceManager.loadService('arcGISMapService');

    const arcGISMap = yield call(arcGISMapService.getMap, 'service-assignment-medical-clearance');
    const mapClickEventChannel = eventChannel(emitter => {
        const unsubscribeClickListener = arcGISMap.on('map-click', payload => {
            emitter(payload);
        });
        const unsubscribeDragListener = arcGISMap.on('graphic-drag-end', payload => {
            emitter(payload);
        });

        // returns unsubscribe method to eventChannel
        return () => {
            unsubscribeClickListener();
            unsubscribeDragListener();
        };
    });

    while (true) {
        const {arcGISPoint} = yield take(mapClickEventChannel);

        yield fork(
            fetchRequest,
            samcActionTypes.FETCH_SAMC_DAMAGE_LOCATION_ADDRESS_REQUEST,
            arcGISRESTService.getLocationAddress,
            {
                longitude: arcGISPoint.longitude,
                latitude: arcGISPoint.latitude,
                langCode: config.ARCGIS_DEFAULT_LANG_CODE,
            },
        );

        const responseAction = yield take([
            samcActionTypes.FETCH_SAMC_DAMAGE_LOCATION_ADDRESS_REQUEST_SUCCEEDED,
            samcActionTypes.FETCH_SAMC_DAMAGE_LOCATION_ADDRESS_REQUEST_FAILED,
        ]);

        if (!responseAction.error) {
            const {response} = responseAction.payload;
            const {arcGISReverseGeocodingLocationDTO} = response;

            yield put({
                type: samcActionTypes.SET_SAMC_REVERSE_GEOCODING_DAMAGE_LOCATION,
                payload: {arcGISReverseGeocodingLocationDTO, serviceAssignmentId},
            });
        }
    }
};

export default onSAMCMapClickFetchDamageLocationAddress;
